export default __webpack_public_path__ + "2da54d1534b3c559014b2e4cab928675.png";